var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.pageType === "commonPage"
        ? _c("form-page", {
            ref: "formPage",
            scopedSlots: _vm._u(
              [
                {
                  key: "endButton",
                  fn: function () {
                    return [_vm._t("endButton")]
                  },
                  proxy: true,
                },
                {
                  key: "endForm",
                  fn: function () {
                    return [_vm._t("endForm")]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        : _vm.pageType === "editPage"
        ? _c("edit-page", { ref: "editPage" })
        : _vm.pageType === "hdPage"
        ? _c("hd-page", { ref: "hdPage" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }